import { Box, Paper, Popper, styled, Typography } from '@material-ui/core';

export const StyledPaper = styled(Paper)({
  width: 560,
  position: 'absolute',
  margin: 'auto',
  padding: '24px',
  borderRadius: 6,
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  boxSizing: 'border-box',
  boxShadow: '0px 12px 16px 0px rgba(0, 0, 0, 0.58)',
});

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  letterSpacing: 0.15,
  fontFamily: 'Red Hat Display, sans-serif',
  color: theme.palette.text.primary,
  margin: 0,
}));

export const FormFields = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
});

export const FooterActions = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 16,
});

export const InviteAutocompletePopper = styled(Popper)({
  zIndex: 1400, // Custom popover z-index to get it over modal
});
